import type { JSX } from 'react';
import { FormGroup, FormParagraph } from '@ksyos/design-system';
import type { ServiceOrganizationSettingRole } from '@common/interfaces/api/serviceOrganizationSettings';
import { getSelectedLanguage } from '@frontend/translate';

type ServiceOrganizationRolesReadProps = {
    currentServiceOrganizationSettingRoles: ServiceOrganizationSettingRole[];
};

export function ServiceOrganizationRolesRead(props: ServiceOrganizationRolesReadProps): JSX.Element {
    const { currentServiceOrganizationSettingRoles } = props;
    const languageFile = getSelectedLanguage();

    return (
        <FormGroup label={languageFile.serviceOrganizationSetting['organizationRole(s)']}>
            <FormParagraph>
                {currentServiceOrganizationSettingRoles.length > 0
                    ? currentServiceOrganizationSettingRoles
                          .map(
                              (serviceOrganizationSettingRole) =>
                                  languageFile.serviceOrganizationRoleEnum[serviceOrganizationSettingRole.role]
                          )
                          .join(', ')
                    : languageFile.common.hasYetToBeConfigured}
            </FormParagraph>
        </FormGroup>
    );
}
